import header from "./grundrisse-mit-AutoCAD.jpg";
import section1 from "./blaupause.webp";
import section2 from "./autocad.jpg";
import section3 from "./erstellung-grundriss-mit-autocad.jpg";
import section4 from "./uebersicht-grundriss-mit-AutoCAD.jpg";
import section5 from "./grundriss-mit-AutoCAD.jpg";

export { header, section1, section2, section3, section4, section5 };
